import * as actionTypes from '../actions/actionTypes';

const initialState = {
  showCreateCustomerTour: false,
  showCreateProductTour: false,
  steps: 'CreateCustomer'
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_CUSTOMER_TOUR:
      return {
        ...state,
        showCreateCustomerTour: !state.showCreateCustomerTour
      };
    case actionTypes.SET_TOUR_STEPS:
      return {
        ...state,
        steps: action.steps
      };
    default:
      return state;
  }
};

export default reducer;
